import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicScheduledSessions } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

export const getScheduledSessions = async ({
  from,
  to,
  organisationId,
}: {
  from: string;
  to: string;
  organisationId?: string;
}): Promise<PublicScheduledSessions[]> => {
  const response = await axiosClient.get(`/analytics/scheduled-sessions`, {
    params: {
      from,
      to,
      organisationId,
    },
  });
  return response.data;
};

export function getScheduledSessionsQueryKey(
  from: string,
  to: string,
  organisationId?: string,
) {
  return ["scheduled-sessions-analytics", from, to, organisationId];
}

export function useGetScheduledSessions(
  {
    from,
    to,
    organisationId,
  }: { from: string; to: string; organisationId?: string },
  queryOptions?: Partial<UseQueryOptions<PublicScheduledSessions[], HttpError>>,
) {
  return useQuery({
    queryKey: getScheduledSessionsQueryKey(from, to, organisationId),
    queryFn: () => getScheduledSessions({ from, to, organisationId }),
    ...queryOptions,
  });
}
